"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
const constants_1 = require("../constants");
function fetch({ groupId, }) {
    return {
        method: 'GET',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/files`,
    };
}
exports.fetch = fetch;
//# sourceMappingURL=http.js.map